import { ARIAS, HIDDEN_CLASS } from '../utils/constants';

let isQuickFilterDropdownsInitialized = false;

const QUICK_FILTER_SELECTOR = '[data-quick-filter]';

const handleQuickFilterToggle = (event) => {
  const openedFilter = event.target.closest(QUICK_FILTER_SELECTOR);
  if (!openedFilter || !openedFilter.open) return;

  const container = openedFilter.closest('[data-filters-container]');
  if (!container) return;

  container.querySelectorAll(`${QUICK_FILTER_SELECTOR}[open]`).forEach(filterEl => {
    if (filterEl !== openedFilter) {
      filterEl.removeAttribute('open');
    }
  });
};

const handleShowMoreToggle = (event) => {
  const toggleEl = event.target.closest('[data-toggle-desktop-filters]');
  if (!toggleEl) return;

  const container = toggleEl.closest('[data-desktop-filter-controls]') ?? toggleEl.closest('[data-filters-container]');
  const extraEl = container?.querySelector('[data-desktop-filter-extra]');
  if (!extraEl) return;

  const isExpanded = toggleEl.getAttribute(ARIAS.EXPANDED) === 'true';

  toggleEl.setAttribute(ARIAS.EXPANDED, String(!isExpanded));
  extraEl.classList.toggle(HIDDEN_CLASS, isExpanded);
  extraEl.classList.toggle('flex', !isExpanded);
  toggleEl.querySelector('[data-more-label]')?.classList.toggle(HIDDEN_CLASS, !isExpanded);
  toggleEl.querySelector('[data-less-label]')?.classList.toggle(HIDDEN_CLASS, isExpanded);
  toggleEl.querySelector('[data-more-icon]')?.classList.toggle(HIDDEN_CLASS, !isExpanded);
  toggleEl.querySelector('[data-less-icon]')?.classList.toggle(HIDDEN_CLASS, isExpanded);

  if (isExpanded) {
    extraEl.querySelectorAll('details[open]').forEach(detailsEl => {
      detailsEl.removeAttribute('open');
    });
  }
};

const initQuickFilterDropdowns = () => {
  if (isQuickFilterDropdownsInitialized) return;

  document.addEventListener('toggle', handleQuickFilterToggle, true);
  document.addEventListener('click', handleShowMoreToggle);

  isQuickFilterDropdownsInitialized = true;
};

export default initQuickFilterDropdowns;
